import { Injectable, inject } from '@angular/core';
import { RestApiService } from '@core/services/rest-api.service';
import { Entity } from '@shared/constants/entity';
import { Observable, Subject, of } from 'rxjs';
import { VehicleDto } from '@pages/vehicles-page/components/vehicles-grid/interfaces';

@Injectable({ providedIn: 'root' })
export class VehiclesTabsService {
  private api = inject(RestApiService);

  selectionChanged$: Subject<void> = new Subject<void>();

  getExtraVehicleData(
    entityId: string | null
  ): Observable<
    Pick<VehicleDto, 'VehicleTypeDescription' | 'Username' | 'ShowRecord'>
  > {
    if (!entityId) return of();
    return this.api.getInfo<
      Pick<VehicleDto, 'VehicleTypeDescription' | 'Username' | 'ShowRecord'>
    >(Entity.Vehicle, entityId, [
      'ShowRecord',
      'VehicleTypeDescription',
      'Username',
    ]);
  }
}
